import VueSocketIO from "vue-socket.io";
import store from "@/store";

export default {
  install: (Vue: any) => {
    Vue.use(
      new VueSocketIO({
        debug: process.env.NODE_ENV !== "production",
        connection: process.env.VUE_APP_SOCKET_SERVER,
        vuex: {
          store,
          actionPrefix: "SOCKET_",
          mutationPrefix: "SOCKET_"
        }
      })
    );
  }
};
